import "@/rbl.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Hub from "@/pages/Hub";
import Library from "@/pages/Library";
import SessionDetail from "@/pages/SessionDetail";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Welcome from "@/pages/Welcome";
import Dashboard from "@/pages/Dashboard";
import PDashboard from "@/pages/participant/PDashboard";
import Worksheets from "@/pages/participant/Worksheets";
import WorksheetDetail from "@/pages/participant/WorksheetDetail";
import Quizzes from "@/pages/participant/Quizzes";
import QuizDetail from "@/pages/participant/QuizDetail";
import Journal from "@/pages/participant/Journal";
import Program from "@/pages/participant/Program";
import Part1 from "@/pages/participant/Part1";
import Part2 from "@/pages/participant/Part2";
import Part2Day from "@/pages/participant/Part2Day";
import AdminPart2 from "@/pages/admin/AdminPart2";
import AdminCheckinLive from "@/pages/admin/AdminCheckinLive";
import QrLogin from "@/pages/QrLogin";
import AdminRoute from "@/components/AdminRoute";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminGroups from "@/pages/admin/AdminGroups";
import AdminContent from "@/pages/admin/AdminContent";
import AdminLive from "@/pages/admin/AdminLive";
import AdminReflections from "@/pages/admin/AdminReflections";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminExport from "@/pages/admin/AdminExport";

function P({ children }) {
  return <ProtectedRoute>{children}</ProtectedRoute>;
}
function A({ children }) {
  return <AdminRoute>{children}</AdminRoute>;
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Hub />} />
          <Route path="/library" element={<Library />} />
          <Route path="/session/:number" element={<SessionDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/qr" element={<QrLogin />} />
          <Route path="/dashboard" element={<P><Dashboard /></P>} />
          <Route path="/app" element={<P><PDashboard /></P>} />
          <Route path="/app/worksheets" element={<P><Worksheets /></P>} />
          <Route path="/app/worksheets/:id" element={<P><WorksheetDetail /></P>} />
          <Route path="/app/quizzes" element={<P><Quizzes /></P>} />
          <Route path="/app/quizzes/:id" element={<P><QuizDetail /></P>} />
          <Route path="/app/journal" element={<P><Journal /></P>} />
          <Route path="/app/program" element={<P><Program /></P>} />
          <Route path="/app/part1" element={<P><Part1 /></P>} />
          <Route path="/app/part1/:number" element={<P><SessionDetail inApp /></P>} />
          <Route path="/app/part2" element={<P><Part2 /></P>} />
          <Route path="/app/part2/:day" element={<P><Part2Day /></P>} />
          <Route path="/admin/part2" element={<A><AdminPart2 /></A>} />
          <Route path="/admin/part2/live" element={<A><AdminCheckinLive /></A>} />
          <Route path="/admin/users" element={<A><AdminUsers /></A>} />
          <Route path="/admin/groups" element={<A><AdminGroups /></A>} />
          <Route path="/admin/content" element={<A><AdminContent /></A>} />
          <Route path="/admin/live" element={<A><AdminLive /></A>} />
          <Route path="/admin/reflections" element={<A><AdminReflections /></A>} />
          <Route path="/admin/analytics" element={<A><AdminAnalytics /></A>} />
          <Route path="/admin/export" element={<A><AdminExport /></A>} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
